import { render, staticRenderFns } from "./dispatcherTask.vue?vue&type=template&id=77b11362&scoped=true"
import script from "./dispatcherTask.vue?vue&type=script&lang=js"
export * from "./dispatcherTask.vue?vue&type=script&lang=js"
import style0 from "./dispatcherTask.vue?vue&type=style&index=0&id=77b11362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b11362",
  null
  
)

export default component.exports